import { useMyCapabilities } from './metadata/capabilities';
import { canExportGridData } from './adminAccess';

export { GRID_EXPORT_CAPABILITY } from './adminAccess';

/**
 * AG Grid exposes export through its Enterprise context menu and Grid API.
 * Keep both CSV and Excel disabled until capability loading has resolved.
 */
export function useCanExportGridData(): boolean {
  const { hasCapability, isLoading, isSuperAdmin } = useMyCapabilities();
  return !isLoading && canExportGridData(isSuperAdmin, hasCapability);
}
